export const capitalizeFirst = (s?: string) => s ? s.charAt(0).toUpperCase() + s.slice(1) : "";